import CM from "../../../../appl/model/system/CM";
import BaseComponent from "../../../../lib/components/BaseComponent";
import "./SandBox.css";
import {createRef} from "react";
import './Nav.css';
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import {BarChart2, PieChart} from "react-feather";

import Link from "../../../../lib/components/Link/Link";
import Button from "../../../../appl/view/components/buttons/Button";

class Nav extends BaseComponent {

  constructor(props) {
    super(props);
    this.themeSwitcher = createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    let themeClassName = CM.get().getGlobalValue('theme');
    for (let i = 0; i < this.themeSwitcher.current.children.length; i++) {
      let option = this.themeSwitcher.current.children[i];
      option.selected = option.value === themeClassName;
    }
  }

  async onChangeLang(e) {
    CM.get().setLanguage(e.target.value);
  }

  async onChangeTheme(e) {
    CM.get().setTheme(e.target.value);
  }

  render() {
    return <HorizontalLayout className='flex-wrap items-center px-5'>
      <Link to='/'>
        <div className="flex-none"><h1>Sandbox-Testfälle</h1></div>
      </Link>
      <div className="flex-1 ml-2">
        <select ref={this.themeSwitcher} className="bg-cn-color-black-804" name="theme" id="theme" onChange={this.onChangeTheme}>
          <option value={CM.STD_DARK}>dark</option>
          <option value={CM.STD_LIGHT}>light</option>
        </select>
      </div>
      <HorizontalLayout className='flex-wrap gap-1' widthFit>
        <Link to='/sb/inputfields'>
          <Button className='m-1' color='secondary'>InputTextField</Button>
        </Link>
        <Link to='/sb/colorpicker'>
          <Button className='m-1' color='secondary'>Colorpicker</Button>
        </Link>
        <Link to='/sb/tagstest'>
          <Button className='m-1' color='secondary'>Tags</Button>
        </Link>
        <Link to='/sb/inputwysiwyg'>
          <Button className='m-1' color='secondary'>WYSIWYG-Editor-Test</Button>
        </Link>
        <Link to='/sb/inputmultilinetest'>
          <Button className='m-1' color='secondary'>Input-Multiline-Test</Button>
        </Link>
        <Link to='/sb/dropdownstest'>
          <Button className='m-1' color='secondary'>DropDowns-Test</Button>
        </Link>
        <Link to='/sb/uploadtest'>
          <Button className='m-1' color='secondary'>Upload-Test</Button>
        </Link>
        <Link to='/sb/accordiontest'>
          <Button className='m-1' color='secondary'>Accordion-Test</Button>
        </Link>
        <Link to='/sb/campaigns'>
          <Button className='m-1' color='secondary'>Campaigns-Test</Button>
        </Link>
        <Link to='/sb/progressbar'>
          <Button className='m-1' color='secondary'>ProgressBar-Test</Button>
        </Link>
        <Link to='/sb/gridtest'>
          <Button className='m-1' color='secondary'>Grid-Test</Button>
        </Link>
        <Link to='/sb/datepicker'>
          <Button className='m-1' color='secondary'>DateTimePicker-Test</Button>
        </Link>
        <Link to='/sb/window'>
          <Button className='m-1' color='secondary'>Window-Test</Button>
        </Link>
        <Link to='/sb/piechart'>
          <Button className='m-1' color='secondary'><PieChart/>Overview-Test</Button>
        </Link>
        <Link to='/sb/barchart'>
          <Button className='m-1' color='secondary'><BarChart2/>BarChart-Test</Button>
        </Link>
        <Link to='/sb/dialogtest'>
          <Button className='m-1' color='secondary'>Dialog-Test</Button>
        </Link>
        <Link to='/sb/extendedfilter'>
          <Button className='m-1' color='secondary'>Erweiterter Filter-Test</Button>
        </Link>
        <Link to='/sb/bctest'>
          <Button className='m-1' color='secondary'>Breadcrumb-Test</Button>
        </Link>
        <Link to='/sb/tabtest'>
          <Button className='m-1' color='secondary'>Tabbar-Test</Button>
        </Link>
        <Link to='/sb/tabtestdynamicadd'>
          <Button className='m-1' color='secondary'>Tabbar Dynamisch add-Test</Button>
        </Link>
        <Link to='/sb/tabtestdynamicadd2'>
          <Button className='m-1' color='secondary'>Tabbar Dynamisch add-Test 2</Button>
        </Link>
        <Link to='/sb/tabtestcustomtab'>
          <Button className='m-1' color='secondary'>Tabbar Custom Tabs-Test</Button>
        </Link>
        <Link to='/sb/faha'>
          <Button className='m-1' color='secondary'>Fahas-Test</Button>
        </Link>
        <Link to='/sb/buttons'>
          <Button className='m-1' color='secondary'>Button-Test</Button>
        </Link>
        <Link to='/sb/wizard'>
          <Button className='m-1' color='secondary'>Wizard-Test</Button>
        </Link>
        <Link to='/sb/variabeln'>
          <Button className='m-1' color='secondary'>Variabeln-Test</Button>
        </Link>
        <Link to='/sb/details'>
          <Button className='m-1' color='secondary'>Detail-Test</Button>
        </Link>
        <Link to='/sb/drag'>
          <Button className='m-1' color='secondary'>Draggable List-Test</Button>
        </Link>
        <Link to='/sb/checkbox'>
          <Button className='m-1' color='secondary'>Checkbox-Test</Button>
        </Link>
        <Link to='/sb/radio'>
          <Button className='m-1' color='secondary'>Radio-Test</Button>
        </Link>
        <Link to='/sb/filtermanager'>
          <Button className='m-1' color='secondary'>FilterManager-Test</Button>
        </Link>
        <Link to='/sb/filtermanager2'>
          <Button className='m-1' color='secondary'>FilterManager-Test 2</Button>
        </Link>
        <Link to='/sb/permissions'>
          <Button className='m-1' color='secondary'>Berechtigungen-Test</Button>
        </Link>
        <Link to='/sb/settings'>
          <Button className='m-1' color='secondary'>Einstellungen-Test</Button>
        </Link>
        <Link to='/sb/profile'>
          <Button className='m-1' color='secondary'>Profile-Test</Button>
        </Link>
        <Link to='/sb/account'>
          <Button className='m-1' color='secondary'>Account-Test</Button>
        </Link>
        <Link to='/sb/clone'>
          <Button className='m-1' color='secondary'>Clone-Test</Button>
        </Link>
        <Link to='/sb/swd'>
          <Button className='m-1' color='secondary'>SWD-Test</Button>
        </Link>
        <Link to='/sb/alert'>
          <Button className='m-1' color='secondary'>Alert-Test</Button>
        </Link>
        <Link to='/sb/memoryTable'>
          <Button className='m-1' color='secondary'>MemoryTable-Test</Button>
        </Link>
        <Link to='/sb/tableExport'>
          <Button className='m-1' color='secondary'>Tabellenexport-Test</Button>
        </Link>
        <Link to='/sb/rippleTest'>
          <Button className='m-1' color='secondary'>Ripple-Test</Button>
        </Link>
      </HorizontalLayout>
    </HorizontalLayout>
  }
}

export default Nav;
